import { Component } from 'react';

export class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-[200px] p-6" data-testid="error-boundary-fallback">
          <div className="text-center space-y-3">
            <div className="text-[14px] font-semibold text-slate-700">Something went wrong</div>
            <div className="text-[11px] text-slate-500 max-w-[300px]">{this.state.error?.message || 'An unexpected error occurred'}</div>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              className="text-[11px] font-medium text-white bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-lg transition-colors"
              data-testid="error-boundary-retry"
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
